@if (activeQuestion()) {
  <div [formGroup]="activeQuestion()" class="cards-settings">
    <div class="cards-settings__title">
      <span class="fs__lg fw__500">Cards</span>
      <span class="fs__md caption">
        The left value serves as the Card Id and it is used in logical rules and is the value submitted as an answer value. The right text is displayed to the
        participants
      </span>
    </div>
    <div formArrayName="cards" class="cards-settings__table">
      <div class="cards-settings__header-row fs__md fw__500">
        <span>Value</span>
        <span>Text</span>
      </div>

      @for (cardCtrl of (activeQuestion().get('cards') | toFormArray).controls; track $index) {
        <div [formGroupName]="$index" class="cards-settings__edit-row">
          <mat-form-field appearance="outline"> <input matInput [disabled]="true" [value]="cardCtrl.value.id" /> </mat-form-field>
          <mat-form-field appearance="outline"> <input matInput [disabled]="true" [value]="cardCtrl.value.text | toPlainText" /> </mat-form-field>
        </div>
      }
    </div>
  </div>
}

@if (questionsToCopyCardsFrom.length > 0) {
  <div class="cards-settings__question-selector">
    <div class="cards-settings__question-select">
      <span class="fs__sm fw__500">Copy the cards from:</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="questionToCopyFromCtrl">
          @for (question of questionsToCopyCardsFrom; track question.id) {
            <mat-option [value]="question.id">{{ question.code }} - {{ question.title | toPlainText }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
